import { render, staticRenderFns } from "./formTheCompanyDividendPaymentInfo.vue?vue&type=template&id=58cee1dd&scoped=true"
import script from "./formTheCompanyDividendPaymentInfo.vue?vue&type=script&lang=js"
export * from "./formTheCompanyDividendPaymentInfo.vue?vue&type=script&lang=js"
import style0 from "./formTheCompanyDividendPaymentInfo.vue?vue&type=style&index=0&id=58cee1dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cee1dd",
  null
  
)

export default component.exports